export const nonRetryableErrorSubStrings = ['Device not found'];

function getErrorMessage(error: unknown): string | undefined {
	if (typeof error === 'object' && error !== null && 'message' in error && typeof error.message === 'string') {
		return error.message;
	}

	return undefined;
}

function getNestedErrorMessages(error: unknown): string[] {
	if (typeof error !== 'object' || error === null) {
		return [];
	}

	const nestedErrors = [];
	if ('errors' in error && Array.isArray(error.errors)) {
		nestedErrors.push(...error.errors);
	}
	if ('graphQLErrors' in error && Array.isArray(error.graphQLErrors)) {
		nestedErrors.push(...error.graphQLErrors);
	}

	return nestedErrors
		.map((nestedError) => getErrorMessage(nestedError))
		.filter((message): message is string => message !== undefined);
}

// Check the Apollo error structure to determine if the error message field
// or one of the nested GraphQL error messages includes one of the substrings
// specified in the errorSubstrings array.
export function apolloErrorContains(apolloError: unknown, errorSubstrings: string[]): boolean {
	if (!apolloError) {
		return true;
	}

	const gqlErrors: string[] = [];
	const topLevelMessage = getErrorMessage(apolloError);
	if (topLevelMessage !== undefined) {
		gqlErrors.push(topLevelMessage);
	}
	gqlErrors.push(...getNestedErrorMessages(apolloError));

	for (const gqlError of gqlErrors) {
		for (const nrError of errorSubstrings) {
			if (gqlError.includes(nrError)) {
				return true;
			}
		}
	}

	return false;
}
